module.exports = __webpack_public_path__ + "img/running-error-clock-alert-outline.2dcf4432.svg";